import { translate } from '../configs';
const emailText = translate('email');
const logInText = translate('logInTitle');

export const fieldPassConfig = {
  copyConfig: {
    loginTitle: logInText,
  },
  loginConfig: {
    copyConfig: {
      usernamePlaceholder: emailText,
      passwordPlaceholder: translate('password'),
      registerLabel: translate('dontHaveAnAccount'),
      registerLink: translate('signUp'),
      submitButton: translate('logIn'),
      helpLink: translate('needHelpLoggingIn'),
      errorMessage: translate('thereWasAnError'),
      requiredCopy: translate('required'),
    },
  },
  registerConfig: {
    copyConfig: {
      emailPlaceholder: emailText,
      passwordPlaceholder: translate('createPassword'),
      confirmPasswordPlaceholder: translate('confirmPassword'),
      birthdayLabel: translate('dateOfBirth'),
      monthPlaceholder: translate('MM'),
      dayPlaceholder: translate('DD'),
      yearPlaceholder: translate('YYYY'),
      optInLabel: translate('receiveCommercialEmails'),
      submitButton: translate('register'),
      policyLabel: translate('agreeToToS'),
      loginLabel: translate('alreadyHaveAnAccount'),
      loginLink: logInText,
    },
  },
  // @TODO: handle tracking here
};
